import React, { useEffect, useState } from "react";
import './Dashboard.css'
import { Col, Row } from "antd";
import Attendance from "../Attendance/Attendance";
import Employees from "../Employees/Employees";
import HelpTickets from "../HelpTickets/HelpTickets";
import NewSideBar from "../NewSideBar/NewSideBar";
import NewHeader from "../NewHeader/NewHeader";
import EmployeeHeader from "../EmployeeHeader/EmployeeHeader";
import AttendTeamAdmin from "../AttendTeamAdmin/AttendTeamAdmin";
import OrgDetails from "../OrgDetails/OrgDetails";
import Overview from "../Overview/Overview";
import Today from "../Today/Today";
import SimpleView from "../Simpleview/SimpleView";
import Alerts from "../Alerts/Alerts";
import History from "../History/History";
import ShiftManagment from "../ShiftManagment/ShiftManagment";
import EmpTeamAdmin from "../EmpTeamAdmin/EmpTeamAdmin";
import AllCurrentStaff from "../AllCurrentStaff/AllCurrentStaff";
import DeactivatedStaff from "../AllCurrentStaff/DeactivatedStaff";
import AddStaff from "../AddStaff/AddStaff";
import EditStaffInfo from "../EditStaffInfo/EditStaffInfo";
import SalesDepartment from "../SalesDepartment/SalesDepartment";
import CurrentStaff from "../AllCurrentStaff/CurrentStaff";
import { useSelector } from "react-redux";
import { STAFF_ROLE } from "../../utils/constant";
function Dashboard() {
  const [collapsed, setCollapsed] = useState(false);
  const [attendance, setAttendance] = useState("atten");
  const [salesDepartmentId, setSalesDepartmentId] = useState(null); 
  const [currentStaffId, setCurrentStaffId] = useState(null); 
  const [click, setClick] = useState('attenteam');
  const [empClick, setEmpClick] = useState('empteamadmin');
  const [sales, setSales] = useState();
  const [currentStaff, setCurrentstaff] = useState();
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  // Load state from localStorage on component mount
  const [firstRender, setFirstRender] = useState(true);

  // ... (existing state and functions)

  // Load saved state from localStorage on component mount only after the first render
  const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};
  useEffect(() => {
   if(userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.EmployeeHeads) && !userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.AttendanceHeads)){

     setAttendance(savedState.attendance || "emp");
     setSalesDepartmentId(savedState.salesDepartmentId || null);
     setCurrentStaffId(savedState.currentStaffId || null);
     setClick(savedState.click || null);
     setEmpClick(savedState.empClick || "empteamadmin");
     setSales(savedState.sales || null);
      setCurrentstaff(savedState.currentStaff || null);
      
    }else{
      setAttendance(savedState.attendance || "atten");
      setSalesDepartmentId(savedState.salesDepartmentId || null);
      setCurrentStaffId(savedState.currentStaffId || null);
      setClick(savedState.click || 'attenteam' );
      setEmpClick(savedState.empClick || "empteamadmin");
      setSales(savedState.sales || null);
       setCurrentstaff(savedState.currentStaff || null);

    }
      // const stateToSave = {
      //   attendance,
      //   salesDepartmentId,
      //   currentStaffId,
      //   click ,
      //   empClick,
      //   sales,
      //   currentStaff,
      // };
      // sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
     
    
  }, [savedState]);

  // Save state to localStorage whenever it changes
 
  
  const handleSalesDepartmentClick = (id) => {
    setSalesDepartmentId(id);
    setSales('salesdepartment');
  };

  const handleCurrentStaffClick = (id) => {
    setCurrentStaffId(id);
    setCurrentstaff('currentStaffDetail');
  };

  const handleBackToHistory = () => {
    setSalesDepartmentId(null);
    setSales(null);
  };
  const handleBackToAllStaff = () => {
    setCurrentStaffId(null);
    setCurrentstaff(null);
  };
  return (
    <div className="h-screen">
      <Row>
        <Col lg={4}>
          <NewSideBar setAttendance={setAttendance} setSales={setSales} setCurrentstaff={setCurrentstaff}/>
        
        </Col>
        <Col lg={20} className="!p-5 dash-scrolll">
          {sales === 'salesdepartment' ? <SalesDepartment salesDepartmentId={salesDepartmentId} onBack={handleBackToHistory}/> : 
          (
            <>
             {currentStaff === 'currentStaffDetail' ? <CurrentStaff currentStaffId={currentStaffId} onBack={handleBackToAllStaff}/>:
              <>

              {attendance === 'atten' ? (
                <NewHeader setAttendance={setAttendance} setClick={setClick} setSales={setSales} setCurrentstaff={setCurrentstaff} click={click}/>
              ) : attendance === 'emp' ? (
                <EmployeeHeader setAttendance={setAttendance} setEmpClick={setEmpClick} empClick={empClick}/>
              ) : attendance === 'help' ? (
                <HelpTickets />
              ) : null}

              {attendance === 'atten' && (
                <div>
                  {click === 'attenteam' ? (
                    <AttendTeamAdmin />
                  ) : click === 'orgdetail' ? (
                    <OrgDetails />
                  ) : click === 'overview' ? (
                    <Overview />
                  ) : click === 'today' ? (
                    <Today />
                  ) : click === 'simple' ? (
                    <SimpleView />
                  ) : click === 'alert' ? (
                    <Alerts />
                  ) : click === 'detail' ? (
                    <History setSales={setSales} onSalesDepartmentClick={handleSalesDepartmentClick}/>
                  ) : click === 'shift' ? (
                    <ShiftManagment />
                  ) : null}
                </div>
              )}

              {attendance === 'emp' && (
                <div>
                  {empClick === 'empteamadmin' ? (
                    <EmpTeamAdmin />
                  ) : empClick === 'currentstaff' ? (
                    <AllCurrentStaff setCurrentstaff={setCurrentstaff} onCurrentStaffClick={handleCurrentStaffClick}/>
                  ) : empClick === 'deactivated' ? (
                    <DeactivatedStaff />
                  ) : empClick === 'addstaff' ? (
                    <AddStaff />
                  ) : empClick === 'editstaff' ? (
                    <EditStaffInfo />
                  ) : null}
                </div>
              )}
            </>
 }
         </> 
          )}
        </Col>
       
      </Row>
    </div>
  );
}

export default Dashboard;